//  -*-web-*-
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme) => ({
    root: { width: 300, },
    margin: { height: theme.spacing(3), },
}));

export function ChartSlider(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(props.val);

    // --------------------------------------------------------------------
    // Handle new value when the slider is changed by the user
    // --------------------------------------------------------------------
    const handleValue = (event, newValue) => {
	//console.log(newValue);
	setValue(newValue);
	if (props.onClick) props.onClick(props, newValue);
    };
    
    const handleSlide = (event, newValue) => {
	setValue(newValue);
    };

    return (
<div className={classes.root}>
  <Typography gutterBottom>
    {props.label}
  </Typography>
  <Slider
    value={value}
    step={props.step}
    max={props.max}
    min={props.min}
    valueLabelDisplay="auto"
    onChangeCommitted={handleValue}
    onChange={handleSlide}
    />
</div>
    );
}
